export default "__VITE_ASSET__fX36LhZt__"